import React from 'react';

import { UiText } from '@shared/ui';

import { HistoryLogItem } from './HistoryLogItem';
import cls from './HistoryLogs.module.css';
import { useHistoryLogs } from '../../model/useHistoryLogs';

interface HistoryLogsProps {
    inventoryGuid: string | null;
    isOpen: boolean;
}

export const HistoryLogs = ({ inventoryGuid, isOpen }: HistoryLogsProps) => {
    const { logsQuery, logs, loadMoreRef, t } = useHistoryLogs(inventoryGuid, isOpen);

    return (
        <div className={cls.historyBlock}>
            <UiText weight="bold" variant="boldPlain" tag="h4">
                {t('EditInventoryModal.return.historyBlockWrapper')}
            </UiText>
            <div>
                {logsQuery.isLoading && (
                    <UiText variant="subPlain" className={cls.historyEmpty}>
                        {t('HistoryLogsBlock.loaderText')}
                    </UiText>
                )}
                {!logsQuery.isLoading && !logs.length && (
                    <UiText variant="subPlain" className={cls.historyEmpty}>
                        {t('HistoryLogsBlock.loaderText')}
                    </UiText>
                )}
                {!!logs.length && (
                    <ul className={cls.historyList}>
                        {logs.map((log, index) => (
                            <HistoryLogItem key={log.guid} log={log} index={index} />
                        ))}
                        <li ref={loadMoreRef} className={cls.loadMoreMarker} aria-hidden="true" />
                    </ul>
                )}
            </div>
        </div>
    );
};
